"use client";

import type { ApiData } from "@tosize/tosize-furniture-configurator/src/components/renderer/data";
import type { CabinetState } from "@tosize/tosize-furniture-configurator/src/context/StoreContext";
import { type Dispatch, type SetStateAction, createContext, useContext } from "react";

interface CabinetInterface {
	api?: ApiData;
	setApi: Dispatch<SetStateAction<ApiData | undefined>>;
	store?: CabinetState;
	setStore: Dispatch<SetStateAction<CabinetState | undefined>>;
	orderData?: string;
	canvasIsCustomized: boolean;
	openSampleDialog: boolean;
	setOpenSampleDialog: Dispatch<SetStateAction<boolean>>;
}

export const CabinetContext = createContext<CabinetInterface>({} as CabinetInterface);

export function useCabinet() {
	const context = useContext(CabinetContext);

	if (context === null) throw new Error("Cabinet context is not available");

	return context;
}
